import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContextDefinition.jsx';
import axios from 'axios';
import { toast } from 'react-toastify';
import './index.css';

// ========================================
// GLOBAL TOKEN EXPIRATION HANDLER
// ========================================
// This interceptor catches ALL 401 (Unauthorized) responses
// and automatically redirects users to login with a notification

axios.interceptors.response.use(
  // Success response - pass through
  (response) => response,
  
  // Error response - check for 401
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token is expired or invalid
      const currentPath = window.location.pathname;
      const isKioskRoute = currentPath.startsWith('/kiosk');
      
      // Clear user data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Show notification
      toast.error('Your session has expired. Redirecting to login...', {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      });
      
      // Redirect after 2 seconds
      setTimeout(() => {
        if (isKioskRoute) {
          window.location.href = '/kiosk/login';
        } else {
          window.location.href = '/login';
        }
      }, 2000);
    }
    
    return Promise.reject(error);
  }
);

// Add request interceptor to attach token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>
);